import { token } from '@atlaskit/tokens';

import evaluateInner from './utils/evaluate-inner';

const scrollbarStyles: string = evaluateInner`/*
 * Feature-gated harmonised scrollbar appearance.
 * Visibility and width remain browser managed.
 *
 * The track is transparent so it matches every surface, which lets the colours be set once on
 * the root and inherited. A per-element var() would make every element's style depend on
 * inherited custom properties.
 */
:root[data-scrollbar-harmonisation] {
  scrollbar-color: ${token('color.border.input', '#8C8F97')} transparent;
}

:root[data-scrollbar-harmonisation]::-webkit-scrollbar-track,
:root[data-scrollbar-harmonisation]::-webkit-scrollbar-corner,
:root[data-scrollbar-harmonisation] *::-webkit-scrollbar-track,
:root[data-scrollbar-harmonisation] *::-webkit-scrollbar-corner {
  background-color: transparent;
  border: 0;
}

:root[data-scrollbar-harmonisation]::-webkit-scrollbar-thumb,
:root[data-scrollbar-harmonisation] *::-webkit-scrollbar-thumb {
  background-color: ${token('color.border.input', '#8C8F97')};
}

@media (forced-colors: active) {
  :root[data-scrollbar-harmonisation] {
    scrollbar-color: auto;
  }

  :root[data-scrollbar-harmonisation]::-webkit-scrollbar-track,
  :root[data-scrollbar-harmonisation]::-webkit-scrollbar-thumb,
  :root[data-scrollbar-harmonisation]::-webkit-scrollbar-corner,
  :root[data-scrollbar-harmonisation] *::-webkit-scrollbar-track,
  :root[data-scrollbar-harmonisation] *::-webkit-scrollbar-thumb,
  :root[data-scrollbar-harmonisation] *::-webkit-scrollbar-corner {
    background-color: revert;
    border: revert;
  }
}`;

export default scrollbarStyles;
